<template>
  <v-app>
    <head>
      <title>Foraje - Find it, Grow it, Share it.</title>
      <meta name="description" content="Find local food producers near you!">
    </head>
    <header>
      <div class="stripes">
        <span/>
        <span/>
        <span/>
        <span/>
        <span/>
      </div>
      <section>
        <v-container>
        <v-row style="position: relative" align="center"
               justify="center">
          <v-col cols="6" style="text-align: center">

                <h1 class="herotext">
                 Local food. Easy.
                </h1>
            <p>Finding local food is hard. Foraje makes it easy</p>

          </v-col>
          <v-col cols="6">
            <v-img src="../assets/farmstand.svg"/>
          </v-col>


        </v-row>
        </v-container>
      </section>
    </header>
    <section>
      <v-container>
        <v-row style="position: relative" align="center" justify="center">
          <v-col cols="4" style="text-align: center">
              <router-link :to="'/shop-finder/'">
            <v-btn class="ma-1" color="primary">Find local food now</v-btn>
              </router-link>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section>
      <v-container>
        <v-row style="position: relative" align="center"
               justify="center">
          <v-col cols="6" style="text-align: center">

            <h3>
              Buy Better, Buy Local
            </h3>
          </v-col>
          <v-col cols="6">
            <p>
              You want to buy local food and support local producers, or maybe you just want to avoid the crowds at grocery stores,
              but it can be a serious pain in the ass.
            </p>
            <p>
              Foraje finds those producers, and we put you directly in touch with them.
            </p>
          </v-col>
          <v-col cols="6" style="text-align: center">

            <h3>
              Sell your produce, even if you're a hobby gardener
            </h3>

          </v-col>
          <v-col cols="6" class="mt-4">
            <p>
              Post your location, list your products on Foraje, and sell your produce.
            </p>
            <p>
              Already have customers? List your current inventory,
              and your current customers can follow your profile and see what you have in stock.
            </p>
          </v-col>
          <v-col cols="6" style="text-align: center">

            <h3>
              It's super simple
            </h3>

          </v-col>
          <v-col cols="6" class="mt-4">
            <p>
              Just <router-link :to="'/sign_up'">sign up</router-link> with your email, then sign in.
            </p>
            <p>
              Go to <router-link :to="'user/shops/'">'My Shops'</router-link>, and create a shop there (if you consider yourself more of a farmstand, or a lady selling out of her house, that's a-ok, we just call everything a shop here). Share your location, and your hours, and then just start listing products! Get this all done in  under 3 minutes easy.
            </p>
            <p>Of course, this is all free</p>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section>
      <v-container>
        <v-row style="position: relative" align="center" justify="center">
          <v-col cols="4" style="text-align: center">
            <router-link :to="'/sign_up'">
              <v-btn class="ma-1" color="primary">Click here to Sign Up now</v-btn>
            </router-link>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section>
      <form @submit.prevent="UserSignUp">
      <v-card color="primary">
      <v-container>
        <v-row style="position: relative">
          <v-col cols="6" >
            <v-card color="#00796b" flat>
              <v-card-title class="white--text" >
            Subscribe to keep up with Foraje's updates
              </v-card-title>
              <v-card-subtitle>
                <p class="white--text" style="text-align: left">We will never give away or sell your email address, and we won't send you spam. Promise.</p>

              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
          <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              name="email"
              label="Email"
              id="email"
              v-model="email"
              type="email"
              solo
              required>
            </v-text-field>
          </v-col>
            <v-col cols="12" md="2" style="text-align: center" class="mt-2"><v-btn>Subscribe</v-btn>
            </v-col>

          </v-row>

      </v-container>
      </v-card>
      </form>
    </section>
    <section>
      <v-container>

      </v-container>
    </section>
      <!--<section>
          <v-row
            align="center"
            justify="center"
            class="white&#45;&#45;text"
          >
            <img src="../assets/foraje.svg" alt="Foraje!" height="200" class="hidden-xs-only">
            <img src="../assets/foraje.svg" alt="Foraje!" height="100" class="hidden-sm-and-up">
          </v-row>
      </section>
      <section>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-title>
                Find Local Producers
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      </section>-->
  </v-app>
</template>

<script>
import axios from 'axios';


export default {
  name: 'LandingPage',
  data: () => ({
    disablebuttons: true,
    password_show: false,
    email: '',
  }),
  computed: {
  },
  props: {
  },
  components: {
  },

  mounted() {
  },
  methods: {
    UserSignUp() {
      if (this.termscheckbox === true) {
        axios.post('rest-auth/registration/', {
          email: this.email,
          password1: this.password,
          password2: this.password,
        })
          .then(() => {
            this.signupalert = true;
          })
          .then(() => {
            if (this.emailcheckbox === true) {
              axios.post('mailinglist/subscribe/', {
                email: this.email,
                email_consent: true,
              });
            }
          })
          .catch(
            () => {
              this.signupalert = false;
              this.erroralert = true;
            },
          );
      } else { this.termsalert = true; }
    },
    MailingListSignUp(){
      axios.post('mailinglist/subscribe/', {
        email: this.email,
        email_consent: this.emailcheckbox,
      })
        .then(this.$parent.$emit('alert-emitted', {
          alert_icon: 'mdi-emoticon-frown-outline',
          alert_color: 'success',
          alert_message: "You've successfully signed up for our mailing list! You can unsubscribe at any time if you wish.",
          alert_model: true,
        }));
    },
    removeEmptyStrings(obj) {
      const newObj = {};
      Object.keys(obj).forEach((prop) => {
        if (obj[prop] !== '') { newObj[prop] = obj[prop]; }
      });
      return newObj;
    },
  },
};
</script>
<style scoped>
  header .stripes {
    display: grid;
    grid: repeat(5, 200px) / repeat(10, 1fr);
    position: absolute;
    width: 100%;
  }

  header .stripes :nth-child(1) {
    grid-column: span 3;
    background: linear-gradient(100grad,rgba(243,251,255,.4),rgba(243,251,255,.15)
    20%,rgba(243,251,255,0));
  }

  header .stripes :nth-child(2) {
    grid-area: 3 / span 3 / auto / -1;
    background: linear-gradient(100grad,rgba(0,119,204,0), rgba(111,166,156,1));
  }

  header .stripes :nth-child(3) {
    grid-row: 4;
    grid-column: span 5;
    background: linear-gradient(100grad,#fafafa 50%,hsla(0,0%,100%,0));
  }
  header .stripes :nth-child(5) {
    grid-area: auto/1/-1/-1;
    background: linear-gradient(100grad,#fafafa 80%,#f5fafd)
  }
  header .stripes {
    transform: skewY(-12deg);
    transform-origin: 0;
  }
  header .stripes {
    background: linear-gradient(#2d796b, #468a7e 10%, #8dbbb3 38%, #add1cb 48%, #eaf1f0 62%)
    repeat scroll;
  }
  .herotext{
    font-weight: 500;
    color: #004b42;
    font-size: 3vmax;
  }

  .v-messages__message {
    color: #ffffff
  }

</style>
